import { render, staticRenderFns } from "./newCssDialog.vue?vue&type=template&id=220bc611&scoped=true&"
import script from "./newCssDialog.vue?vue&type=script&lang=js&"
export * from "./newCssDialog.vue?vue&type=script&lang=js&"
import style0 from "./newCssDialog.vue?vue&type=style&index=0&id=220bc611&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220bc611",
  null
  
)

export default component.exports